const infoCardsMobileToggler = () => {

    const btn = document.getElementsByClassName('js-info-cards-mobile-toggler-btn')[0];

    if (!btn) {
        return;
    }

    const hiddenClass = 'mobile-hidden';
    let isClosed = true;
    const togglingElementsCollection = document.querySelectorAll(`.${hiddenClass}`);

    const toggleState = () => {
        isClosed = !isClosed;
    };

    function open(elemCollection) {
        Array.from(elemCollection).forEach((elem) => {
            elem.classList.remove(hiddenClass);
        });
        toggleState();
    }

    function close(elemCollection) {
        Array.from(elemCollection).forEach((elem) => {
            elem.classList.add(hiddenClass);
        });
        toggleState();
    }

    function toggleButtonView(button) {
        const buttonText = isClosed ? 'Все данные' : 'Скрыть';
        const buttonArrowStyle = isClosed ? 'transform: rotate(0deg)' : 'transform: rotate(180deg)';
        button.getElementsByClassName('js-btn-text')[0].innerHTML = buttonText;
        button.getElementsByClassName('js-btn-arrow')[0].style.cssText = buttonArrowStyle;
    }

    btn.addEventListener('click', (event) => {
        if (isClosed) {
            open(togglingElementsCollection);
        } else {
            close(togglingElementsCollection);
        }
        toggleButtonView(event.currentTarget);
    });

};

export default infoCardsMobileToggler;
